export default __webpack_public_path__ + "static/media/video-placeholder.2490f8d4.png";